"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pointsListReducer = void 0;
var utils_1 = require("../../../utils");
var pointsListReducer = function (state, action) {
    switch (action) {
        case 'close-dialog':
            return (0, utils_1.IList)();
        default:
            return state.push(action);
    }
};
exports.pointsListReducer = pointsListReducer;
